import { UnitModel } from '../../Services/api/v2/Models/UnitModel';
export class UnitHelper {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getUnitUrl(unitId: number, unitArray: any) {
		if (!this.getUnit(unitId, unitArray).IsClientEntrance) {
			unitId = this.getClosestOfferFromCurrent(unitId, unitArray).Id;
		}

		return this.getFullUrlAlias(unitId, unitArray);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getClosestOfferFromCurrent(parentId: number | null, unitArray: any) {
		const getParent = (parentId: number | null) => {
			if (!parentId) return null;

			const unit = this.getUnit(parentId, unitArray);

			return unit.IsClientEntrance ? unit : getParent(unit.ParentId);
		};

		return getParent(parentId);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getUnit(unitId: number, unitArray: any) {
		const unit = unitArray.find((u) => u.Id === unitId) || null;

		return unit;
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getFullUrlAlias(unitId: number, unitArray: any): string {
		const unit = this.getUnit(unitId, unitArray);

		if (unit.ParentId === null) return `/${unit.UrlAlias}`;

		return `${this.getFullUrlAlias(unit.ParentId, unitArray)}/${unit.UrlAlias}`;
	}

	createFlatUnitArray(root: UnitModel) {
		const key = 'Children';
		let flatten = [root];

		if (root[key] && root[key].length > 0) {
			root[key].forEach((c) => {
				// Not including not listed here. Might bite me in the but later
				c.closestEntranceId =
					(root.IsClientEntrance && root.IsListedToClients) || root.closestEntranceId ? root.closestEntranceId || root.Id : null;
			});

			return flatten.concat(root[key].map((child) => this.createFlatUnitArray(child)).reduce((a, b) => a.concat(b), []));
		}

		return flatten;
	}
}
